export function buildSOPPrompt(data) {
  return `You are a senior admissions consultant and academic writing specialist who has helped hundreds of doctoral candidates gain admission to top-tier programmes worldwide.

Write a Statement of Purpose (SOP) for the following doctoral candidate.

CANDIDATE DETAILS:
Name: ${data.candidateName || data.name}
University: ${data.university}
Programme: ${data.programme}
Professional Background: ${data.professionalBackground || data.background}
Motivation: ${data.motivation}
Research Interest: ${data.researchInterest}

TARGET LENGTH: ${data.targetWords || 650} words (±50 words)

WRITING REQUIREMENTS:

Structure (do not use section headings — this is flowing prose):
Opening paragraph: Establish professional identity and the problem or question that drives this candidate toward doctoral study. Should be specific and concrete — not "I have always been passionate about..." Start with a scene, a decision, a realisation, or a professional moment that created intellectual urgency.
Middle paragraphs: Professional background relevant to the research. What have they seen or done that created the research question? What limitations did they encounter in practice that only scholarly research could address?
Research focus paragraph: What specifically do they intend to research, and why does it matter? State the research territory precisely. Connect it to existing scholarly debates without being pedantic.
Programme fit paragraph: Why this programme, this university? Be specific — not generic praise.
Closing: What will they do with this doctorate? What contribution to practice or scholarship do they intend?

HUMANIZER RULES — strictly apply:
- Write in the first person, but not confessionally — the tone is professional and direct
- Do NOT use: "passionate", "dream", "journey", "transformative", "leverage", "impactful", "synergies", "holistic approach", "vibrant", "groundbreaking"
- Do NOT open with a quote
- Do NOT use the phrase "As a [profession]..."
- Vary sentence length. Let some sentences be short. Let some ideas breathe.
- This person has accomplishments — let them be stated plainly, without modesty hedges
- The closing should feel earned, not aspirational-poster generic
- Read the SOP aloud mentally — it should sound like an intelligent person talking, not a marketing document

Write only the SOP text. No headings, no meta-commentary.`
}
